import { useEffect, useRef, useState } from "react";

export function AnimatedCounter({ target, suffix = "" }) {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 },
    );
    io.observe(node);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    const n = parseInt(target.replace(/[^0-9]/g, ""), 10);
    if (!n) {
      setCount(target);
      return undefined;
    }
    let s = 0;
    const step = Math.ceil(n / 90);
    const timer = setInterval(() => {
      s += step;
      if (s >= n) {
        s = n;
        clearInterval(timer);
      }
      setCount(s.toLocaleString());
    }, 16);
    return () => clearInterval(timer);
  }, [visible, target]);

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  );
}
